<accounting-set-default-configuration
  [canBeSkipped]="true"
  (event-progress)="handleEventEmitted($event)"
  [allowCreateLabor]="true"
  [hideDefaultProductConfig]="true"
></accounting-set-default-configuration>
